var HERFUR_MARQUEE_MAX_SETS = 24;

function layoutHerfurMarquee(track) {
  var viewport = track.closest('.herfur-marquee__viewport');
  if (!viewport) return;

  var originals = track.querySelectorAll('.herfur-marquee__set:not([data-herfur-marquee-clone])');
  if (!originals.length) return;

  var set = originals[0];
  var setWidth = set.getBoundingClientRect().width;
  if (setWidth <= 0) return;

  var viewportWidth = viewport.getBoundingClientRect().width;

  // The track scrolls left by exactly one set per loop, so the sets that remain
  // must still cover the whole viewport at the moment it resets. That needs
  // one set for the part scrolling away plus enough sets to fill the viewport.
  var needed = Math.ceil(viewportWidth / setWidth) + 1;
  if (needed < 2) needed = 2;
  if (needed > HERFUR_MARQUEE_MAX_SETS) needed = HERFUR_MARQUEE_MAX_SETS;

  var clones = track.querySelectorAll('.herfur-marquee__set[data-herfur-marquee-clone]');
  var current = originals.length + clones.length;
  if (current === needed && track.style.getPropertyValue('--herfur-marquee-set-width') === setWidth + 'px') {
    return;
  }

  track.style.animationPlayState = 'paused';

  // Clone the last authored set — it carries no theme-editor block attributes.
  var template = originals[originals.length - 1];

  for (var i = current; i < needed; i++) {
    var clone = template.cloneNode(true);
    clone.setAttribute('data-herfur-marquee-clone', '');
    track.appendChild(clone);
  }

  for (var j = current - 1; j >= needed; j--) {
    var extra = track.querySelector('.herfur-marquee__set[data-herfur-marquee-clone]:last-child');
    if (!extra) break;
    extra.remove();
  }

  track.style.setProperty('--herfur-marquee-set-width', setWidth + 'px');
  void track.offsetWidth;
  track.style.animationPlayState = 'running';
}

function layoutAllHerfurMarquees(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var tracks = scope.querySelectorAll('.herfur-marquee__track');
  if (!tracks.length) return;

  tracks.forEach(function (track) {
    layoutHerfurMarquee(track);
  });
}

function initHerfurMarquees() {
  layoutAllHerfurMarquees(document);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      layoutAllHerfurMarquees(document);
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      layoutAllHerfurMarquees(document);
    }, 150);
  });

  document.addEventListener('shopify:section:load', function (event) {
    layoutAllHerfurMarquees(event.target);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHerfurMarquees);
} else {
  initHerfurMarquees();
}
